import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row gx-2" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "card rounded-3 h-100 bg-gradient-primary text-white" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "calendar-outline" })
  ])
], -1)
const _hoisted_7 = { class: "col-md-10" }
const _hoisted_8 = { class: "m-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", null, "Nominal Terbayar", -1)
const _hoisted_10 = { class: "d-inline" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "card h-100" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3 text-primary" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "receipt-outline" })
  ])
], -1)
const _hoisted_16 = { class: "col-md-10" }
const _hoisted_17 = { class: "m-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h5", null, "Total Tagihan", -1)
const _hoisted_19 = { class: "d-inline text-primary" }
const _hoisted_20 = { class: "row pt-2" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6 p-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("ion-icon", { name: "arrow-back-outline" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Kembali ")
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = /*#__PURE__*/_createVNode("ion-icon", { name: "cloud-upload-outline" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Impor Rincian")
const _hoisted_31 = {
  key: 1,
  type: "button",
  class: "btn btn-primary mr-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#importTxtModal"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("ion-icon", { name: "document-text-outline" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Import Tagihan")
const _hoisted_34 = {
  key: 2,
  class: "float-end"
}
const _hoisted_35 = {
  key: 0,
  class: "btn-group",
  role: "group"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("ion-icon", { name: "return-down-back-outline" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Unpublish ")
const _hoisted_38 = /*#__PURE__*/_createVNode("ion-icon", { name: "send-outline" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Publish")
const _hoisted_40 = /*#__PURE__*/_createVNode("ion-icon", { name: "document-text-outline" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Export")
const _hoisted_42 = { class: "row p-2" }
const _hoisted_43 = { class: "col-md-3" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "" }, "Tahun Ajar :", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("option", { value: "" }, "Pilih Tahun Ajar", -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { for: "" }, "Tipe Tagihan :", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("option", { value: "" }, "Semua Tipe Tagihan", -1)
const _hoisted_49 = { class: "col-md-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { for: "" }, "Tagihan :", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("option", { value: "" }, "Semua Tagihan", -1)
const _hoisted_52 = { class: "col-md-3" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { for: "" }, "Kelas :", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("option", { value: "" }, "Semua Kelas", -1)
const _hoisted_55 = { class: "row p-2" }
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { for: "" }, "Status :", -1)
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { for: "" }, "Publikasi :", -1)
const _hoisted_60 = { class: "col-md-3" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", { for: "" }, "Bulan :", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("option", { value: "" }, "Semua Bulan", -1)
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "" }, "Nama Siswa :", -1)
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "container-autocomplete" }
const _hoisted_67 = { class: "row p-2" }
const _hoisted_68 = { class: "col-md-3" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { for: "" }, "Cari :", -1)
const _hoisted_70 = { class: "col-md-1" }
const _hoisted_71 = /*#__PURE__*/_createVNode("ion-icon", { name: "search-outline" }, null, -1)
const _hoisted_72 = { class: "row pt-2" }
const _hoisted_73 = { class: "col-md-12" }
const _hoisted_74 = { class: "card" }
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "d-inline" }
const _hoisted_79 = /*#__PURE__*/_createVNode("label", { for: "" }, "Tampilkan :", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("option", { value: "20" }, "20", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("option", { value: "50" }, "50", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("option", { value: "100" }, "100", -1)
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "float-end" }
const _hoisted_85 = { class: "table table-borderless table-data fw-bold" }
const _hoisted_86 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "No"),
    /*#__PURE__*/_createVNode("th", null, "Nama Siswa"),
    /*#__PURE__*/_createVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", null, "Jumlah Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Jumlah Tagihan Terbayar"),
    /*#__PURE__*/_createVNode("th", null, "Terpublikasi"),
    /*#__PURE__*/_createVNode("th")
  ])
], -1)
const _hoisted_87 = { class: "fw-bold" }
const _hoisted_88 = { class: "badge bg-primary" }
const _hoisted_89 = {
  key: 0,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_90 = {
  key: 1,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_91 = {
  key: 2,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_92 = {
  key: 3,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_93 = {
  key: 4,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_94 = {
  key: 5,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_95 = { class: "text-primary" }
const _hoisted_96 = { class: "text-primary" }
const _hoisted_97 = { class: "form-check form-switch" }
const _hoisted_98 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-to-square fa-lg" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-to-square fa-lg" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-circle-info fa-lg" }, null, -1)
const _hoisted_101 = {
  id: "importTxtModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_102 = { class: "modal-dialog modal-lg" }
const _hoisted_103 = { class: "modal-content" }
const _hoisted_104 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Import Txt Tagihan"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_105 = { class: "modal-body" }
const _hoisted_106 = /*#__PURE__*/_createVNode("ion-icon", { name: "cloud-upload-outline" }, null, -1)
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" Mulai Impor")
const _hoisted_108 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)
const _hoisted_109 = {
  id: "refundModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_110 = { class: "modal-dialog modal-lg" }
const _hoisted_111 = { class: "modal-content" }
const _hoisted_112 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Refund Detail"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_113 = { class: "modal-body" }
const _hoisted_114 = { class: "table table-bordered" }
const _hoisted_115 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Tanggal Refund"),
    /*#__PURE__*/_createVNode("th", null, "Jumlah"),
    /*#__PURE__*/_createVNode("th", null, "Metode"),
    /*#__PURE__*/_createVNode("th", null, "Catatan"),
    /*#__PURE__*/_createVNode("th", null, "Status")
  ])
], -1)
const _hoisted_116 = { class: "badge bg-info" }
const _hoisted_117 = /*#__PURE__*/_createVNode("td", {
  colspan: "4",
  class: "text-end fw-bold"
}, "Total Refund", -1)
const _hoisted_118 = { class: "fw-bold" }
const _hoisted_119 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_router_link = _resolveComponent("router-link")
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_edit_user_bill = _resolveComponent("edit-user-bill")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Tagihan Siswa",
      link1: "Tagihan Siswa"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("h3", _hoisted_10, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.totalPaid)), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("h3", _hoisted_19, _toDisplayString(_ctx.totalBill), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("h6", null, [
                  _createVNode(_component_router_link, {
                    tag: "a",
                    to: "/",
                    class: "btn btn-light rounded-pill"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _hoisted_27
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                (_ctx.canAccessBillUserImport)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "btn btn-primary mr-1 float-end",
                      to: "/bill/user/import"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29,
                        _hoisted_30
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.canCreate)
                  ? (_openBlock(), _createBlock("button", _hoisted_31, [
                      _hoisted_32,
                      _hoisted_33
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.bills.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      (_ctx.canUpdate)
                        ? (_openBlock(), _createBlock("div", _hoisted_35, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn btn-outline-danger",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.publish(false)))
                            }, [
                              _hoisted_36,
                              _hoisted_37
                            ]),
                            _createVNode("button", {
                              type: "button",
                              class: "btn btn-outline-success mr-1",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.publish(true)))
                            }, [
                              _hoisted_38,
                              _hoisted_39
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.canRead)
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary mr-1",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportBill()))
                          }, [
                            _hoisted_40,
                            _hoisted_41
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.param.school_year_id = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"},
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getBill()))
                }, [
                  _hoisted_45,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schoolYears, (sy) => {
                    return (_openBlock(), _createBlock("option", {
                      key: sy.school_year_id,
                      label: sy.name,
                      value: sy.school_year_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.param.school_year_id]
                ])
              ]),
              _createVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.param.bill_type_id = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"},
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getBill && _ctx.getBill(...args)))
                }, [
                  _hoisted_48,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billTypes, (b) => {
                    return (_openBlock(), _createBlock("option", {
                      key: b.id,
                      label: b.name,
                      value: b.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.param.bill_type_id]
                ])
              ]),
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.param.spp_bill_id = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"}
                }, [
                  _hoisted_51,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billOption, (b) => {
                    return (_openBlock(), _createBlock("option", {
                      key: b.id,
                      label: b.name,
                      value: b.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.param.spp_bill_id]
                ])
              ]),
              _createVNode("div", _hoisted_52, [
                _hoisted_53,
                _withDirectives(_createVNode("select", {
                  disabled: _ctx.param.school_year_id == '' || (_ctx.searchField.length > 3 && _ctx.param.user_id != ''),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.param.class_id = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"}
                }, [
                  _hoisted_54,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.classes, (c) => {
                    return (_openBlock(), _createBlock("option", {
                      key: c.class_id,
                      label: c.name,
                      value: c.class_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 8, ["disabled"]), [
                  [_vModelSelect, _ctx.param.class_id]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.param.status = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"}
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderStatuses, (name, id) => {
                    return (_openBlock(), _createBlock("option", {
                      key: id,
                      label: name,
                      value: id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.param.status]
                ])
              ]),
              _createVNode("div", _hoisted_58, [
                _hoisted_59,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.param.is_published = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"}
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.publishStatus, (name, id) => {
                    return (_openBlock(), _createBlock("option", {
                      key: id,
                      label: name,
                      value: id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.param.is_published]
                ])
              ]),
              _createVNode("div", _hoisted_60, [
                _hoisted_61,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.param.month = $event)),
                  class: "text-primary form-select",
                  style: {"width":"90%"}
                }, [
                  _hoisted_62,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.months, (value, key) => {
                    return (_openBlock(), _createBlock("option", {
                      key: key,
                      label: value.id,
                      value: key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.param.month]
                ])
              ]),
              _createVNode("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createVNode("input", {
                  placeholder: "Nama Siswa",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.searchField = $event)),
                  class: "text-primary form-select",
                  type: "text",
                  autocomplete: "off",
                  onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.getSuggestions && _ctx.getSuggestions(...args))),
                  onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.modal = true))
                }, null, 544), [
                  [_vModelText, _ctx.searchField]
                ]),
                (_ctx.students.length > 0 && _ctx.modal && _ctx.searchField.length > 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_65, [
                      _createVNode("ul", _hoisted_66, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.students, (result) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "item-autocomplete",
                            key: result.user_id,
                            onClick: ($event: any) => (_ctx.setSearch(result))
                          }, _toDisplayString(result.name), 9, ["onClick"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("div", _hoisted_68, [
                _hoisted_69,
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  type: "text",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.param.keyword = $event)),
                  placeholder: "Nama / Deskripsi Tagihan",
                  style: {"display":"inherit"}
                }, null, 512), [
                  [_vModelText, _ctx.param.keyword]
                ])
              ]),
              _createVNode("div", _hoisted_70, [
                _createVNode("a", {
                  class: "btn btn-primary",
                  href: "javascript:void(0)",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loadData('refresh'))),
                  style: {"position":"absolute","bottom":"24px"}
                }, [
                  _hoisted_71
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_72, [
      _createVNode("div", _hoisted_73, [
        _createVNode("div", _hoisted_74, [
          _createVNode("div", _hoisted_75, [
            _createVNode("div", _hoisted_76, [
              _createVNode("div", _hoisted_77, [
                _createVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _withDirectives(_createVNode("select", {
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadData('refresh'))),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.param.limit = $event)),
                    class: "d-inline text-primary form-select form-select-noborder"
                  }, [
                    _hoisted_80,
                    _hoisted_81,
                    _hoisted_82
                  ], 544), [
                    [_vModelSelect, _ctx.param.limit]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_83, [
                _createVNode("div", _hoisted_84, [
                  _createVNode(_component_v_pagination, {
                    modelValue: _ctx.currentPage,
                    "onUpdate:modelValue": [
                      _cache[20] || (_cache[20] = ($event: any) => (_ctx.currentPage = $event)),
                      _ctx.onPageChanged
                    ],
                    pages: _ctx.totalPage,
                    "range-size": 1
                  }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
                ])
              ])
            ]),
            _createVNode("table", _hoisted_85, [
              _hoisted_86,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bills, (bill, i) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: i++
                  }, [
                    _createVNode("td", null, _toDisplayString(i + _ctx.param.offset), 1),
                    _createVNode("td", _hoisted_87, [
                      _createVNode(_component_router_link, {
                        to: '/bill/'+bill.user_id,
                        tag: "a"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bill.user_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("td", null, [
                      _createTextVNode(_toDisplayString(bill.bill.name) + " ", 1),
                      _createVNode("span", _hoisted_88, _toDisplayString(_ctx.getMonth(bill.id)), 1)
                    ]),
                    _createVNode("td", null, [
                      (bill.status == _ctx.constants.BILL_PAID)
                        ? (_openBlock(), _createBlock("div", _hoisted_89, "LUNAS"))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_OVERPAID)
                        ? (_openBlock(), _createBlock("div", _hoisted_90, "KELEBIHAN"))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_PENDING)
                        ? (_openBlock(), _createBlock("div", _hoisted_91, "AKTIF"))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_UNPAID)
                        ? (_openBlock(), _createBlock("div", _hoisted_92, "BELUM BAYAR"))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_REFUNDED)
                        ? (_openBlock(), _createBlock("div", _hoisted_93, "REFUNDED"))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_PARTIAL_REFUND)
                        ? (_openBlock(), _createBlock("div", _hoisted_94, "REFUND SEBAGIAN"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", _hoisted_95, " Rp" + _toDisplayString(_ctx.toLocaleString(bill.total_amount + bill.late_charge)), 1),
                    _createVNode("td", _hoisted_96, " Rp" + _toDisplayString(_ctx.toLocaleString(bill.total_paid)), 1),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_97, [
                        _createVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          checked: bill.is_published == 1,
                          onClick: ($event: any) => (_ctx.publishByID(bill, $event))
                        }, null, 8, ["checked", "onClick"])
                      ])
                    ]),
                    _createVNode("td", null, [
                      (bill.status == _ctx.constants.BILL_PENDING || bill.status == _ctx.constants.BILL_UNPAID)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-link-gray",
                            onClick: ($event: any) => (_ctx.edit('edit', bill.spp_bill_id, bill.id)),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#billUserModal"
                          }, [
                            _hoisted_98
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_PAID || bill.status == _ctx.constants.BILL_OVERPAID)
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-link-gray",
                            onClick: ($event: any) => (_ctx.edit('detail', bill.spp_bill_id, bill.id)),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#billUserModal"
                          }, [
                            _hoisted_99
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (bill.status == _ctx.constants.BILL_REFUNDED || bill.status == _ctx.constants.BILL_PARTIAL_REFUND)
                        ? (_openBlock(), _createBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-sm btn-link-gray",
                            onClick: ($event: any) => (_ctx.openRefundModal(bill.id))
                          }, [
                            _hoisted_100
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_edit_user_bill, {
      data: _ctx.data,
      math_operations: _ctx.math_operations,
      onSave: _ctx.save
    }, null, 8, ["data", "math_operations", "onSave"]),
    _createVNode("div", _hoisted_101, [
      _createVNode("div", _hoisted_102, [
        _createVNode("div", _hoisted_103, [
          _hoisted_104,
          _createVNode("div", _hoisted_105, [
            _createVNode("input", {
              type: "file",
              class: "form-control",
              id: "file",
              ref: "file",
              onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleFileUpload()))
            }, null, 544),
            _createVNode("button", {
              class: "btn btn-outline-primary",
              type: "button",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.importBillTxt()))
            }, [
              _hoisted_106,
              _hoisted_107
            ])
          ]),
          _hoisted_108
        ])
      ])
    ]),
    _createVNode("div", _hoisted_109, [
      _createVNode("div", _hoisted_110, [
        _createVNode("div", _hoisted_111, [
          _hoisted_112,
          _createVNode("div", _hoisted_113, [
            _createVNode("table", _hoisted_114, [
              _hoisted_115,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.refundDetails, (detail, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, _toDisplayString(detail.refund_date), 1),
                    _createVNode("td", null, "Rp" + _toDisplayString(_ctx.toLocaleString(detail.amount)), 1),
                    _createVNode("td", null, _toDisplayString(detail.method), 1),
                    _createVNode("td", null, _toDisplayString(detail.note), 1),
                    _createVNode("td", null, [
                      _createVNode("span", _hoisted_116, _toDisplayString(detail.status), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode("tfoot", null, [
                _createVNode("tr", null, [
                  _hoisted_117,
                  _createVNode("td", _hoisted_118, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.totalRefund)), 1)
                ])
              ])
            ])
          ]),
          _hoisted_119
        ])
      ])
    ])
  ], 64))
}